import { render, staticRenderFns } from "./OngoingLottoForm.vue?vue&type=template&id=7c2f6222&"
import script from "./OngoingLottoForm.vue?vue&type=script&lang=js&"
export * from "./OngoingLottoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports